<template>
  <GmapCustomMarker
    :key="`vehicle-marker-${id}`"
    :marker="{ lat: vehicle.latitude, lng: vehicle.longitude }"
    :offsetY="25"
  >
    <div class="vehicle-marker text-center" :class="{ active }" @click="$emit('click')">
      <div class="vehicle-marker__popover">
        <div class="vehicle-marker__popover-text">
          {{ vehicle.licensePlate }}
        </div>
        <div v-if="vehicle?.status == 'not_available'" class="vehicle-marker__popover-icon">
          <i class="mc-fa icon-outline_truck-moving" />
        </div>
      </div>

      <img
        :id="`vehicle-icon-${id}`"
        :src="
          require(`@/assets/images/vehicles/${vehicle.icon}/${vehicle.icon}-${
            vehicleMappings[vehicle.calculatedMotionStatus]
          }.png`)
        "
        :style="`transform: rotate(${parseInt(vehicle.direction)}deg);`"
        :alt="`mceasy-liveview-${vehicle.icon}-icon`"
      />
    </div>
  </GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import vehicleMappings from '../lib/constants/vehicle-mappings.js'

export default {
  components: {
    GmapCustomMarker,
  },
  props: {
    id: {
      type: String,
      Number,
      default: null,
    },
    vehicle: {
      type: Object,
      default: () => {},
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  data() {
    return {
      vehicleMappings,
    }
  },
}
</script>

<style lang="scss" scoped>
.vehicle-marker {
  cursor: pointer;
  
  &.active {
    &:before {
      content: '';
      width: 50px;
      height: 50px;
      background-color: rgba(1, 19, 61, 0.4);
      border-radius: 100%;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      top: 35px;
      animation: carico 1.2s infinite;
      transition: 0.3s;
    }
    &:after {
      content: '';
      width: 70px;
      height: 70px;
      background-color: rgba(1, 19, 61, 0.25);
      border-radius: 100%;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      top: 25px;
      animation: carico 1.2s infinite;
      transition: 0.3s;
    }
  }

  &__popover {
    width: fit-content;
    display: flex;
    border: 1px solid $mep-color-text-400;
    border-radius: 4px;

    &-text {
      color: $white;
      background-color: $mep-color-text-400;
      font-size: 12px;
      padding: 8px 10px;
    }

    &-icon {
      background-color: $yellow-100;
      border-radius: 0 4px 4px 0;
      padding: 8px 10px;
    }
  }
}

.mc-fa::before {
  color: $yellow-500 !important;
  font-size: 16px;
}
</style>
